<template>
    <div class="reportes">
        <h3>REPORTES</h3>
        <br />

        <v-container class="reportes-dates" fluid>
            <v-row>
                <v-col cols="12" md="6">
                    <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="startFormated"
                                label="Inicio"
                                persistent-hint
                                prepend-icon="mdi-calendar"
                                v-bind="attrs"
                                @blur="start = parseDate(startFormated)"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="start"
                            no-title
                            @input="menu1 = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>

                <v-col cols="12" md="6">
                    <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="endFormated"
                                label="Fin"
                                persistent-hint
                                prepend-icon="mdi-calendar"
                                v-bind="attrs"
                                @blur="end = parseDate(endFormated)"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="end"
                            no-title
                            @input="menu2 = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>

                <v-col cols="12" md="6">
                    <v-select
                        :items="electionTypes"
                        v-model="electionType"
                        item-text="label"
                        item-value="eleccion"
                        label="Tipo de elección"
                        class="ml-10"
                    ></v-select>
                </v-col>

                <v-col>
                    <v-btn
                        class="mb-5"
                        color="teal"
                        dark
                        @click="searchElections"
                        :disabled="isLoading"
                    >
                        <i class="fas fa-search"></i> &nbsp; Buscar
                    </v-btn>
                </v-col>

                <br />
                <v-col cols="12 my-5" v-if="isLoading" key="loading">
                    <i class="fas fa-spinner fa-spin fa-2x"></i>
                </v-col>
                <v-col
                    cols="12"
                    v-if="!isLoading && elections.length > 0"
                    key="elections"
                >
                    <v-data-table :items="elections" :headers="headers">
                    </v-data-table>

                    <v-row class="mb-5">
                        <v-col cols="12">
                            <v-btn
                                class="mx-1 mb-4"
                                @click="downloadStatistics"
                                :disabled="isLoadingReports || csvProgress > 0"
                            >
                                <i class="fas fa-download"></i> &nbsp;
                                Estadístico Votantes
                            </v-btn>

                            <v-btn
                                class="mx-1 mb-4"
                                @click="downloadStatisticsReports"
                                :disabled="isLoadingReports || csvProgress > 0"
                            >
                                <i class="fas fa-download"></i> &nbsp;
                                Estadístico Resultados
                            </v-btn>

                            <v-btn
                                class="mx-1 mb-4"
                                @click="downloadWinners"
                                :disabled="isLoadingReports || csvProgress > 0"
                            >
                                <i class="fas fa-download"></i> &nbsp; Planillas
                                Ganadoras
                            </v-btn>

                            <v-btn
                                class="mx-1 mb-4"
                                @click="downloadCounselors"
                                :disabled="isLoadingReports || csvProgress > 0"
                            >
                                <i class="fas fa-download"></i> &nbsp;
                                Consejeros
                            </v-btn>
                        </v-col>

                        <v-col
                            cols="12 my-5"
                            v-if="isLoadingReports || csvProgress > 0"
                            key="loading-report"
                        >
                            <i class="fas fa-spinner fa-spin fa-2x"></i> <br />
                            <v-row class="my-2">
                                <v-col cols="10" offset="1">
                                    <v-progress-linear
                                        color="light-blue"
                                        height="25"
                                        v-model="csvProgress"
                                        striped
                                    >
                                        <template v-slot:default="{ value }">
                                            <strong style="color: blue"
                                                >{{ value }}%</strong
                                            >
                                        </template>
                                    </v-progress-linear>
                                </v-col>
                            </v-row>
                            Por favor espere, esto puede tomar unos minutos
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    data() {
        return {
            isLoading: false,
            isLoadingReports: false,
            menu1: false,
            menu2: false,
            start: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            end: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            startFormated: this.formatDate(
                new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
            ),
            endFormated: this.formatDate(
                new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
            ),
            electionType: 30,
            electionTypes: [
                { eleccion: 29, label: 'Acádemicos' },
                { eleccion: 30, label: 'Alumnos' },
            ],
        };
    },
    watch: {
        start() {
            this.startFormated = this.formatDate(this.start);
        },
        end() {
            this.endFormated = this.formatDate(this.end);
        },
    },
    computed: {
        ...mapGetters({
            elections: 'reportes/elections',
            csvProgress: 'reportes/csvProgress',
            token: 'socket/token',
        }),
        headers() {
            return [
                { text: 'Id', value: 'id', sortable: true },
                { text: 'Descripción', value: 'description', sortable: true },
                { text: 'Inicio', value: 'start_date', sortable: true },
                { text: 'Fin', value: 'end_date', sortable: true },
            ];
        },
    },
    methods: {
        ...mapActions({
            getElections: 'reportes/getElections',
            getStatistics: 'reportes/getStatistics',
            getWinners: 'reportes/getWinners',
            getStatisticsResults: 'reportes/getStatisticsResults',
            getCounselors: 'reportes/getCounselors',
        }),
        ...mapMutations({
            setElections: 'reportes/SET_ELECTIONS',
            setCSVStatus: 'reportes/SET_CSV_STATUS',
        }),
        catchError(error) {
            console.error(error);
            this.$store.dispatch('errorMessage', 'Ha ocurrido un error');
        },
        stopLoadingReport() {
            setTimeout(() => (this.isLoadingReports = false), 500);
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split('-');
            return `${month}/${day}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;

            const [month, day, year] = date.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        },
        searchElections() {
            this.isLoading = true;

            this.getElections({
                start: new Date(`${this.start}T00:00:00`).getTime(),
                end: new Date(`${this.end}T23:59:59`).getTime(),
                type: this.electionType,
            })
                .catch(error => {
                    console.error(error);

                    this.$store.dispatch(
                        'errorMessage',
                        'Ha ocurrido un error'
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        downloadStatistics() {
            if (this.isLoadingReports) {
                return;
            }

            this.isLoadingReports = true;

            const stDateStr = `${this.start}T00:00:00`;
            const endDateStr = `${this.end}T23:59:59`;
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                timeZone: 'America/Mexico_City',
            };

            const mexicoCityStDate = new Date(stDateStr).toLocaleString(
                'en-US',
                options
            );
            const mexicoCityEndDate = new Date(endDateStr).toLocaleString(
                'en-US',
                options
            );

            const payload = {
                start: new Date(mexicoCityStDate).getTime(),
                end: new Date(mexicoCityEndDate).getTime(),
                type: this.electionType,
                token: this.token,
                electionIds: this.elections
                    .map(election => election.id)
                    .join('-'),
            };

            this.getStatistics(payload)
                .catch(this.catchError)
                .finally(this.stopLoadingReport);
        },

        downloadStatisticsReports() {
            if (this.isLoadingReports) {
                return;
            }
            this.isLoadingReports = true;

            const stDateStr = `${this.start}T00:00:00`;
            const endDateStr = `${this.end}T23:59:59`;
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                timeZone: 'America/Mexico_City',
            };

            const mexicoCityStDate = new Date(stDateStr).toLocaleString(
                'en-US',
                options
            );
            const mexicoCityEndDate = new Date(endDateStr).toLocaleString(
                'en-US',
                options
            );

            const payload = {
                start: new Date(mexicoCityStDate).getTime(),
                end: new Date(mexicoCityEndDate).getTime(),
                type: this.electionType,
                token: this.token,
                electionIds: this.elections
                    .map(election => election.id)
                    .join('-'),
            };

            this.getStatisticsResults(payload)
                .catch(this.catchError)
                .finally(this.stopLoadingReport);
        },
        downloadWinners() {
            if (this.isLoadingReports) {
                return;
            }
            this.isLoadingReports = true;
            const stDateStr = `${this.start}T00:00:00`;
            const endDateStr = `${this.end}T23:59:59`;
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                timeZone: 'America/Mexico_City',
            };

            const mexicoCityStDate = new Date(stDateStr).toLocaleString(
                'en-US',
                options
            );
            const mexicoCityEndDate = new Date(endDateStr).toLocaleString(
                'en-US',
                options
            );

            const payload = {
                start: new Date(mexicoCityStDate).getTime(),
                end: new Date(mexicoCityEndDate).getTime(),
                type: this.electionType,
                token: this.token,
                electionIds: this.elections
                    .map(election => election.id)
                    .join('-'),
            };

            this.getWinners(payload)
                .catch(this.catchError)
                .finally(this.stopLoadingReport);
        },
        downloadCounselors() {
            if (this.isLoadingReports) {
                return;
            }
            this.isLoadingReports = true;

            const stDateStr = `${this.start}T00:00:00`;
            const endDateStr = `${this.end}T23:59:59`;
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                timeZone: 'America/Mexico_City',
            };

            const mexicoCityStDate = new Date(stDateStr).toLocaleString(
                'en-US',
                options
            );
            const mexicoCityEndDate = new Date(endDateStr).toLocaleString(
                'en-US',
                options
            );

            const payload = {
                start: new Date(mexicoCityStDate).getTime(),
                end: new Date(mexicoCityEndDate).getTime(),
                type: this.electionType,
                token: this.token,
                electionIds: this.elections
                    .map(election => election.id)
                    .join('-'),
            };

            this.getCounselors(payload)
                .catch(this.catchError)
                .finally(this.stopLoadingReport);
        },
    },
    created() {
        this.setElections([]);
        this.setCSVStatus({ progress: 0 });
    },
};
</script>

<style scoped lang="scss">
.reportes {
    padding: 10px;
    &-table {
        margin-bottom: 10px;
    }

    &-dates {
        background-color: white;
        padding: 50px 0 0;
    }
}
.btn {
    margin: 0 10px;
}

.contrato {
    margin: 10px 0;
}
</style>
